import type { User } from '@/types'
import { isPodTransporter } from '@/utils/authPaths'

export function transporterDocumentJourneyPath(documentNo?: string | number): string {
  const base = '/transporter/document-journey'
  if (documentNo == null || documentNo === '') return base
  return `${base}/${documentNo}`
}

export function resolveDocumentJourneyPath(
  user: User | null | undefined,
  documentNo?: string | number
): string {
  if (isPodTransporter(user)) return transporterDocumentJourneyPath(documentNo)
  if (documentNo == null || documentNo === '') return '/documentJourney'
  return `/documentJourney/${documentNo}`
}
